import { createGlobalStyle } from "styled-components";

export const GlobalStyled = createGlobalStyle`

*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Roboto Mono', monospace;
    font-family: 'DM Mono', monospace;
}

html, body{
    min-width: 360px;
    
}

`;
